module.exports = __webpack_public_path__ + "static/media/001_Entrada_Mobile.9777bf3e.mp4";